import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";

import Hero from "../components/Hero";
import CategoryFilter from "../components/CategoryFilter";
import MenuFilterComp from "../components/MenuFilterComp";

export default function Rings() {
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    onTop();
  }, [routePath]);

  const queryParams = new URLSearchParams(routePath.search);
  const { priceRange } = useParams();
  let price = null;
  const isAllProductsPage = routePath.pathname === '/products';
  if (priceRange) {
    const parts = priceRange.split('-');
    if (parts.length === 2) {
      const secondPart = parts[1];
      const parsed = parseInt(secondPart);
      if (!isNaN(parsed)) {
        price = parsed; // Numeric price, like 2000
      } else if (secondPart === "exclusive") {
        price = secondPart; // Keyword, like "prem"
      }
    }
  }
  console.log("priceRange --->", priceRange);
  console.log("price --->", price);
  console.log("All --->", isAllProductsPage);
  let categoriesQuery = queryParams.get("categories") || null;
  let menuQuery = queryParams.get("menu") || null;
  let subCategoriesQuery = queryParams.get("subcategories") || null;
  let collectionsQuery = queryParams.get("collections") || null;
  let isLatestArrivalQuery = queryParams.get("isLatestArrival") || null;
  let genderQuery = queryParams.get("gender") || null;
  let stylesQuery = queryParams.get("styles") || null;

  return (
    <div>
      {["JEWELLERY SETS", "WHATS NEW", "FOR HIM"].includes(menuQuery) ? (
        <Hero
          cat={
            menuQuery === "JEWELLERY SETS"
              ? "jewellerySet"
              : menuQuery === "WHATS NEW"
                ? "whatsNew"
                : "forHim"
          }
        />
      ) : isAllProductsPage || priceRange ? (
        <div></div>
      ) : (
        <MenuFilterComp
          categoriesQuery={categoriesQuery}
          collectionsQuery={collectionsQuery}
          subCategoriesQuery={subCategoriesQuery}
          isLatestArrivalQuery={isLatestArrivalQuery}
          genderQuery={genderQuery}
          stylesQuery={stylesQuery}
        />
      )}

      <CategoryFilter
        name="Collections"
        categoriesQuery={categoriesQuery}
        collectionsQuery={collectionsQuery}
        subCategoriesQuery={subCategoriesQuery}
        isLatestArrivalQuery={isLatestArrivalQuery}
        genderQuery={genderQuery}
        stylesQuery={stylesQuery}
        maxPrice={price}
      />
    </div>
  );
}
